import type React from 'react'

import { useAiGenerating } from '@/hooks/selectors/useAiGenerating'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

/**
 * A shimmering gradient border drawn around the whole viewport while the AI
 * assistant is working, so it is obvious on the canvas (not only in the chat
 * sidebar) that work is in progress and the screen has not frozen (OCT-4826).
 *
 * Always mounted so it can fade both in and out (opacity transition on the
 * `visible` class); purely decorative with `pointer-events: none`, so an
 * invisible frame never intercepts clicks.
 */
export const AiWorkingFrame: React.FC = () => {
  const aiGenerating = useAiGenerating()

  return (
    <div
      className={clsJoin(css.frame, aiGenerating && css.visible)}
      aria-hidden
    />
  )
}
